module.exports = __webpack_public_path__ + "static/main-457f6f49e20b1134ea0bdfc9c963e9cc.jpg";